import { render, staticRenderFns } from "./my-performance-global.vue?vue&type=template&id=b80cd740&"
import script from "./my-performance-global.vue?vue&type=script&lang=js&"
export * from "./my-performance-global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports